<template>
    <div class="appMain-container">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
  </div>
</template>
<script>
export default {
    name: 'AppMain'
}
</script>
<style lang="less" scoped>
.appMain-container {
    margin-top: 50px;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/AppMain.vue